import Scene from "./Scene";
import common from "../common";

export default class HelpScene extends Scene {
    constructor() {
        super();

        this._overlay = null;
        this._muteButton = null;
        this._homeButton = null;
        this._panel = null;
        this._panelTextArray = [];
        this._panelBackgroundArray = [];
        this._helpMap = new Map();
        this._stageTracker = 0;
        this._currentStage = 0;

        this._bkMusic = null;
    }

    init() {
        super.init();

        const assets = P3.assets;

        this._overlay = new PIXI.Graphics();
        this._overlay.interactive = true;
        this._overlay.visible = false;
        this._overlay.alpha = 0;
        this.addChild(this._overlay);

        let states = new P3.ButtonStates();
        states.normal = assets.texture("btn_primary_small_off");
        states.over = assets.texture("btn_primary_small_over");
        states.down = assets.texture("btn_primary_small_down");
        states.icon = assets.texture("icon_home_off");

        this._homeButton = new P3.Button(states);
        this._homeButton.visible = false;
        this._homeButton.signals.click.add(this.onHomeButtonClick, this);
        this.addChild(this._homeButton);

        this._helpMap.set("mixing_1", {
            text: "Drag ingredients to the bowl",
            img: "help_mix"
        });
        this._helpMap.set("mixing_2", {
            text: "Follow the gestures shape",
            img: "help_mix"
        });
        this._helpMap.set("mixing_3", {
            text: "Drag ingredients to the bowl",
            img: "help_mix"
        });
        this._helpMap.set("cutting_1", {
            text: "Roll the dough",
            img: "help_roll"
        });
        this._helpMap.set("cutting_2", {
            text: "Select a dough cutter",
            img: "help_roll"
        });
        this._helpMap.set("cutting_3", {
            text: "Cut shapes out of the dough",
            img: "help_decorate"
        });
        this._helpMap.set("oven_1", {
            text: "Bake the cookies",
            img: "help_bake"
        });
        this._helpMap.set("decorate_1", {
            text: "Decorate the cookies",
            img: "help_decorate"
        });
        this._helpMap.set("photo_1", {
            text: "Take a photo",
            img: "help_photo"
        });

        // this._currentStage = common.currentStage - 1;
        // this._stageTracker = common.currentStage - 1;
        // console.log(this._currentStage);

        this.createHelpPanel();

        this._bkMusic = P3.audio.playMusic("music_pausehelp_menu_00");
        this._bkMusic.play();
    }

    destroy() {
        // clean up goes here
        super.destroy();
    }

    resize() {
        super.resize();

        this._overlay.clear();
        this._overlay.beginFill(0x0, 0.7);
        this._overlay.drawRect((common.STAGE_WIDTH - P3.View.width) * 0.5, 0, P3.View.width, P3.View.height);
        this._overlay.endFill();

        this._panel.x = common.STAGE_WIDTH * 0.5;
        this._panel.y = common.STAGE_HEIGHT * 0.5;
    }

    animateIn() {
        let self = this;

        this._overlay.alpha = 0;
        new P3.utils.TWEEN.Tween(this._overlay, this.tweens)
            .to({
                alpha: 1
            }, 340)
            .easing(P3.utils.TWEEN.Easing.Linear.None)
            .yoyo(false)
            .delay(0)
            .onStart(function () {
                self._overlay.visible = true;
            })
            .start();

        this._panel.scale.set(0);
        new P3.utils.TWEEN.Tween(this._panel.scale, this.tweens)
            .to({
                x: .8,
                y: .8
            }, 340)
            .easing(P3.utils.Easing.Back2.Out)
            .yoyo(false)
            .delay(500)
            .onStart(function () {
                self._panel.visible = true;
            })
            .start();
    }

    update() {
        super.update();
    }

    createHelpPanel() {
        const assets = P3.assets;

        this._panel = new PIXI.Sprite(assets.texture("pause._panel_bg"));
        this._panel.anchor.set(0.5);
        this._panel.visible = false;
        this.addChild(this._panel);
        //
        let states = new P3.ButtonStates();
        states.normal = assets.texture("btn_primary_large_off");
        states.over = assets.texture("btn_primary_large_over");
        states.down = assets.texture("btn_primary_large_down");
        states.icon = assets.texture("icon_play_large_off");

        //close button
        this._panel.closeButton = new P3.Button(states);
        this._panel.closeButton.signals.click.add(this.onCloseButtonClick, this);
        this._panel.closeButton.x = this._panel.x + 12;
        this._panel.closeButton.y = this._panel.y + (this._panel.height * 0.5) - 125;
        this._panel.addChild(this._panel.closeButton);

        states.normal = assets.texture("btn_primary_small_off");
        states.over = assets.texture("btn_primary_small_over");
        states.down = assets.texture("btn_primary_small_down");
        states.icon = assets.texture("icon_sound_off");
        states.iconAlt = assets.texture("icon_mute_off");

        this._panel._muteButton = new P3.MuteButton(states);
        this._panel._muteButton.x = this._panel.x + 250;
        this._panel._muteButton.y = this._panel.y + (this._panel.height * 0.5) - 135;
        this._panel.addChild(this._panel._muteButton);

        states = new P3.ButtonStates();
        states.normal = assets.texture("btn_primary_small_off");
        states.over = assets.texture("btn_primary_small_over");
        states.down = assets.texture("btn_primary_small_down");
        states.icon = assets.texture("icon_home_off");

        this._panel._homeButton = new P3.Button(states);
        this._panel._homeButton.signals.click.add(this.onHomeButtonClick, this);
        this._panel._homeButton.x = this._panel.x - 215;
        this._panel._homeButton.y = this._panel.y + (this._panel.height * 0.5) - 135;
        this._panel.addChild(this._panel._homeButton);

        //help background
        this._panel.background = new PIXI.Sprite(P3.assets.texture(this._helpMap.get(common.currentHelpStage).img));
        this._panel.background.anchor.set(0.5);
        this._panel.background.y -= 60;
        this._panel.addChild(this._panel.background);

        //help text
        this._panel.text = new PIXI.extras.BitmapText(this._helpMap.get(common.currentHelpStage).text, {
            font: "30px VAGRounded",
            align: "center"
        });
        this._panel.text.anchor.set(0.5);
        this._panel.text.y += 125;
        this._panel.text.tint = 0xFFFFFF;
        this._panel.addChild(this._panel.text);
    }

    onHomeButtonClick() {
        this.signals.next.dispatch(this);
        this._bkMusic.stop();
        P3.audio.playSound("sfx_btn_accept_00");
    }

    onCloseButtonClick() {
        this.signals.previous.dispatch(this);
        this._bkMusic.stop();
        P3.audio.playSound("sfx_btn_accept_00");
    }

    onNextArrowClick() {
        // this._stageTracker + 1 > this._stagesRequired.length - 1 ? this._stageTracker = 0 : this._stageTracker += 1;
        // this._currentStage = this._stagesRequired[this._stageTracker] - 1;
        // this._panel.text.text = this._panelTextArray[this._currentStage];
        // this._panel.background.texture = P3.assets.texture(this._panelBackgroundArray[this._currentStage]);
    }

    onPreviousArrowClick() {
        // this._stageTracker - 1 < 0 ? this._stageTracker = this._stagesRequired.length - 1 : this._stageTracker -= 1;
        // this._currentStage = this._stagesRequired[this._stageTracker] - 1;
        // this._panel.text.text = this._panelTextArray[this._currentStage];
        // this._panel.background.texture = P3.assets.texture(this._panelBackgroundArray[this._currentStage]);
    }
}